exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 896px) {\n.c-btn--narrow[data-v-444f97aa] {\n    padding: 11px 101px;\n}\n}\n.number-cell[data-v-444f97aa] {\n  text-align: right;\n}\n.w-30[data-v-444f97aa]{\n  width: 30% !important;\n}\n\n", ""]);

// exports
